/**
 * The chat's one disclosure: a closed-by-default native `<details>` (keyboard and screen-reader
 * reach for free) with a chevron row, used for a turn's steps and an answer's figures.
 */
import type { ReactNode } from "react";
import { ChevronRight } from "lucide-react";

const SUMMARY =
  "flex w-fit cursor-pointer list-none items-center gap-2 rounded-md py-1 text-xs text-muted-foreground " +
  "transition-colors duration-200 hover:text-foreground focus-visible:outline-none " +
  "focus-visible:ring-2 focus-visible:ring-ring [&::-webkit-details-marker]:hidden";

interface DisclosureProps {
  /** The summary row's content after the chevron. */
  label: ReactNode;
  children: ReactNode;
}

export function Disclosure({ label, children }: DisclosureProps) {
  return (
    <details className="group/disclosure">
      <summary className={SUMMARY}>
        <ChevronRight
          className="h-4 w-4 shrink-0 motion-safe:transition-transform motion-safe:duration-200 group-open/disclosure:rotate-90"
          aria-hidden
        />
        {label}
      </summary>
      <div className="mt-1 ml-2 border-l border-border pl-4">{children}</div>
    </details>
  );
}
